<div class="card p-3 rounded border">
  <div *ngIf="member$ | async as member">
    <ng-container *ngIf="!allowEditing">
      <div class="">
        <label class="readonly-label mb-0">{{ 'edit.account.details.firstname.label' | translate }}</label>
        <div class="d-flex bg-muted ps-0 p-2 m-0 mt-1 rounded">
          <span class="ms-3">{{ member.FirstName }}</span>
        </div>
      </div>
      <div class="">
        <label class="readonly-label mb-0 mt-3">{{ 'edit.account.details.lastname.label' | translate }}</label>
        <div class="d-flex bg-muted ps-0 p-2 m-0 mt-1 rounded">
          <span class="ms-3">{{ member.Surname }}</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="allowEditing">
      <form [formGroup]="accountsDetailsForm">
        <div class="form-floating position-relative mb-3">
          <input
            id="firstname"
            class="form-control font-size-14"
            type="text"
            placeholder="Enter first name"
            formControlName="FirstName"
            readonly="readonly"
            disabled
          />
          <label class="editable-label fw-normal">{{ 'edit.account.details.firstname.label' | translate }}</label>
        </div>
        <div class="form-floating position-relative mb-3">
          <input
            id="lastname"
            class="form-control font-size-14"
            type="text"
            placeholder="Enter last name"
            formControlName="Surname"
            readonly="readonly"
            disabled
          />
          <label class="editable-label fw-normal">{{ 'edit.account.details.lastname.label' | translate }}</label>
        </div>
      </form>
    </ng-container>
    <fgb-edit-shipping-address (saved)="shippingSaved($event)" (editing)="allowEditing = $event"></fgb-edit-shipping-address>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
